import React from "react";
import { Card, Flex, LoadingIndicator, Tag, Text } from "@jsq/ds/core";
import {
  AiSummaryCard_Style,
  AiSummaryMetric_Style,
  AiSummaryMetrics_Style,
} from "./styles_vanilla.css";

export type AiSummary = {
  highRiskCount: number;
  mediumRiskCount: number;
  lowRiskCount: number;
  totalMatches: number;
};

export const AiSummaryCard: React.FC<{
  summary: AiSummary;
  isLoading: boolean;
  isProcessed: boolean;
  isPolling?: boolean;
}> = ({ summary, isLoading, isProcessed, isPolling = false }) => {
  let statusContent = null;
  if (isLoading || isPolling) {
    statusContent = (
      <Flex alignItems="center" gap={8}>
        <LoadingIndicator size="small" />
        <Text variant="secondary-sm">AI Processing...</Text>
      </Flex>
    );
  } else if (isProcessed) {
    statusContent = <Text variant="secondary-sm">Processed</Text>;
  }

  return (
    <Card className={AiSummaryCard_Style}>
      <Flex alignItems="center" justifyContent="space-between" css={{ marginBottom: "16px" }}>
        <Text variant="strong-lg">AI Risk Assessment Summary</Text>
        {statusContent}
      </Flex>
      <Flex className={AiSummaryMetrics_Style}>
        <Flex className={AiSummaryMetric_Style}>
          <Text variant="secondary-sm">Total Matches</Text>
          <Text variant="strong-md">{summary.totalMatches}</Text>
        </Flex>
        <Flex className={AiSummaryMetric_Style}>
          <Text variant="secondary-sm">High Risk</Text>
          <Flex alignItems="center" gap={8}>
            <Tag variant="danger">{summary.highRiskCount}</Tag>
          </Flex>
        </Flex>
        <Flex className={AiSummaryMetric_Style}>
          <Text variant="secondary-sm">Medium Risk</Text>
          <Flex alignItems="center" gap={8}>
            <Tag variant="warning">{summary.mediumRiskCount}</Tag>
          </Flex>
        </Flex>
        <Flex className={AiSummaryMetric_Style}>
          <Text variant="secondary-sm">Low Risk</Text>
          <Flex alignItems="center" gap={8}>
            <Tag variant="success">{summary.lowRiskCount}</Tag>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
};
